import axios, { AxiosResponse } from 'axios';
import { Distributor } from 'src/admin-entity/interface/distributor/distributor.interface';
import { InvoiceList } from 'src/admin-entity/interface/invoice/invoice-list.interface';
import { InvoiceLog } from 'src/admin-entity/interface/invoice/invoice-log.interface';
import { OrderItemProductStatusLog } from 'src/admin-entity/interface/order/order-item-product-status-log.interface';
import { Page } from 'src/admin-entity/interface/page/page-info.interface';
import { BASE_URL } from 'src/config/api';
import client, { noTimeoutClient } from './client';
import { format } from 'date-fns';
import { EmptyInvoice } from 'src/admin-entity/interface/invoice/empty-invoice.interface';
import { ExcelDownloadSummary } from 'src/admin-entity/interface/excel/excel-download-summary.interface';
import { CumaDeliveryItemGroupList } from 'src/admin-entity/interface/distributor/cuma-delivery-item-group-list.interface';
import { InvoiceData } from 'src/admin-entity/interface/invoice/invoice-data.interface';
import { DeliveryInvoiceNumberUpdate } from 'src/admin-entity/interface/invoice/delivery-invoice-number-update';
import { OrderItem } from 'src/admin-entity/interface/order/order-item.interface';
import { PurchaseOrderTargetGroups } from 'src/admin-entity/interface/distributor/purchase-order-target-group.interface';
import {
    CreatePurchaseOrderBody,
    PurchaseOrderCreateResult,
} from 'src/admin-entity/interface/distributor/purchase-order-create-result.interface';
import { PurchaseOrderHistoryGroupListDetail } from 'src/admin-entity/interface/distributor/purchase-order-history-group-list-detail.interface';
import {
    PurchaseOrderHistory,
    PurchaseOrderHistoryQuery,
    PurchaseOrderHistoryResendInfo,
} from 'src/admin-entity/interface/distributor/purchase-order-history.interface';
import {
    InvoiceRegisterLog,
    InvoiceRegisterLogDetail,
    InvoiceRegisterLogQuery,
    InvoiceRegisterResult,
} from 'src/admin-entity/interface/invoice/invoice-register-log.interface';

export const getInvoiceListOld = (): Promise<AxiosResponse<CumaDeliveryItemGroupList[]>> => {
    return noTimeoutClient.get(`${BASE_URL}/v1/admin/distributors/delivery-items`);
};

// export const getInvoiceList = (): Promise<AxiosResponse<Distributor[]>> => {
//     return noTimeoutClient.get(`${BASE_URL}/v2/admin/distributors/delivery-items`);

export const getInvoiceList = (): Promise<AxiosResponse<Distributor[]>> => {
    return noTimeoutClient.get(`${BASE_URL}/v3/admin/distributors/delivery-items`);
};

// 발주서 전체 목록을 가져온다. 엑셀 생성할때쓰자.
export const getDistributorsInvoiceListAll = (
    distributorId: number,
): Promise<AxiosResponse<CumaDeliveryItemGroupList>> => {
    return noTimeoutClient.get(`${BASE_URL}/v2/admin/distributors/${distributorId}/delivery-items/all`);
};

// export const getDistributorsInvoiceList = (
//     distributorId: number,
//     page: number,
//     take = 10,
// ): Promise<AxiosResponse<InvoiceList>> => {
//     return noTimeoutClient.get(
//         `${BASE_URL}/v2/admin/distributors/${distributorId}/delivery-items/detail?page=${page}&take=${take}`,
//     );
// };

export const getDistributorsInvoiceList = (
    distributorId: number,
    page: number,
    take = 10,
): Promise<AxiosResponse<InvoiceList>> => {
    return noTimeoutClient.get(
        `${BASE_URL}/v3/admin/distributors/${distributorId}/delivery-items/detail?page=${page}&take=${take}`,
    );
};

// export const getCreatedInvoiceListOld = (
//     take: number,
//     page: number,
// ): Promise<AxiosResponse<CumaDeliveryItemGroupList[]>> => {
//     return noTimeoutClient.get(`${BASE_URL}/v1/admin/delivery-items?take=${take}&page=${page}`);
// };

export const getCreatedInvoiceListOld = (
    take: number,
    page: number,
): Promise<AxiosResponse<CumaDeliveryItemGroupList[]>> => {
    return noTimeoutClient.get(`${BASE_URL}/v2/admin/delivery-items?take=${take}&page=${page}`);
};

export const getCreatedInvoiceList = (
    take: number,
    page: number,
): Promise<AxiosResponse<CumaDeliveryItemGroupList[]>> => {
    return noTimeoutClient.get(`${BASE_URL}/v3/admin/distributors/order-form-group?take=${take}&page=${page}`);
};

export const addDeliveryItemsOld = (
    deliveryItemGroupList: CumaDeliveryItemGroupList[],
): Promise<AxiosResponse<{ updatedCount: number }>> => {
    return noTimeoutClient.post(`${BASE_URL}/v1/admin/delivery-items`, deliveryItemGroupList);
};

export const addDeliveryItemsv1 = (distributorIds: number[]): Promise<AxiosResponse<{ updatedCount: number }>> => {
    return noTimeoutClient.post(`${BASE_URL}/v1/admin/delivery-items`, distributorIds);
};

export const addSingleDeliveryItem = (id: number): Promise<AxiosResponse<{ excelFileUrl: string }>> => {
    return noTimeoutClient.post(`${BASE_URL}/v2/admin/distributors/${id}/delivery-items`);
};

// export const addDeliveryItem = (
//     distributorIds: number[],
// ): Promise<AxiosResponse<{ distributorName: string; excelFileUrls: string[] }[]>> => {
//     return noTimeoutClient.post(`${BASE_URL}/v2/admin/distributors/delivery-items`, { distributorIds });
// };

// 발주서 생성 타입 (default : 기본 발주서, shipmentDate : 당일 출고 발주서)
export type DeliveryItemType = 'default' | 'shipmentDate';

// 발주서 생성
// - 목록 버튼 : distributorIds 만 전달
// - 상세 팝업 버튼 : distributorIds [업체 1개] + selectionKeys [체크한 행] 전달 (체크한 묶음만 발주)
// 팝업을 연 뒤 다른 곳에서 발주되어 없어진 묶음이 있으면 400
export const addDeliveryItem = (
    deliveryItemType: DeliveryItemType,
    distributorIds: number[],
    selectionKeys?: string[],
): Promise<AxiosResponse<PurchaseOrderCreateResult>> => {
    const body: CreatePurchaseOrderBody = { distributorIds, ...(selectionKeys && { selectionKeys }) };
    return noTimeoutClient.post(
        `${BASE_URL}/v1/admin/purchase-order/delivery-items?deliveryItemType=${deliveryItemType}`,
        body,
    );
};

// 업체별 발주 대상 상품 그룹 조회 (selectionKey 는 발주서 생성 API 에 그대로 전달)
export const getPurchaseOrderTargetGroups = (
    distributorId: number,
): Promise<AxiosResponse<PurchaseOrderTargetGroups>> => {
    return client.get(`${BASE_URL}/v1/admin/purchase-order/targets/${distributorId}/groups`);
};

// 발주 내역 조회 (기간 최대 3개월)
export const getPurchaseOrderHistories = ({
    page,
    take,
    beginDate,
    endDate,
    distributorName,
}: PurchaseOrderHistoryQuery): Promise<AxiosResponse<Page<PurchaseOrderHistory>>> => {
    return client.get(`${BASE_URL}/v1/admin/purchase-order/histories`, {
        params: {
            page,
            take,
            beginDate: format(new Date(beginDate), 'yyyy-MM-dd'),
            endDate: format(new Date(endDate), 'yyyy-MM-dd'),
            distributorName: distributorName || undefined,
        },
    });
};

// 발주서 상세 내역 조회 (hasItems = false 면 기존 발주라 상품 목록 없음)
export const getPurchaseOrderHistoryGroupListDetail = (
    groupListId: number,
): Promise<AxiosResponse<PurchaseOrderHistoryGroupListDetail>> => {
    return client.get(`${BASE_URL}/v1/admin/purchase-order/histories/group-lists/${groupListId}`);
};

// 발주서 재발송 정보 조회
export const getPurchaseOrderResendInfo = (
    groupListId: number,
): Promise<AxiosResponse<PurchaseOrderHistoryResendInfo>> => {
    return client.get(`${BASE_URL}/v1/admin/purchase-order/histories/group-lists/${groupListId}/resend-info`);
};

// 발주 메일 재발송 (발송 실패 건 재발송용 — 새 접속 비밀번호 발급 후 입력한 수신 이메일로 발송)
// 메일 자동 발주된 건만 가능 (그 외 400)
export const resendPurchaseOrderMail = (groupListId: number, email: string): Promise<AxiosResponse<void>> => {
    return client.post(`${BASE_URL}/v1/admin/purchase-order/histories/group-lists/${groupListId}/resend-mail`, {
        email,
    });
};

// 송장 등록 내역 조회 (기간 최대 3개월, registerPath / status 생략 시 전체)
export const getInvoiceRegisterLogs = ({
    page,
    take,
    beginDate,
    endDate,
    distributorName,
    registerPath,
    status,
}: InvoiceRegisterLogQuery): Promise<AxiosResponse<Page<InvoiceRegisterLog>>> => {
    return client.get(`${BASE_URL}/v1/admin/purchase-order/invoice-register-logs`, {
        params: {
            page,
            take,
            beginDate: format(new Date(beginDate), 'yyyy-MM-dd'),
            endDate: format(new Date(endDate), 'yyyy-MM-dd'),
            distributorName: distributorName || undefined,
            registerPath,
            status,
        },
    });
};

// 송장 등록 내역 상세 조회 (엑셀 전체 다운로드는 files[].excelFileUrl 사용)
export const getInvoiceRegisterLogDetail = (
    invoiceRegisterLogId: number,
): Promise<AxiosResponse<InvoiceRegisterLogDetail>> => {
    return client.get(`${BASE_URL}/v1/admin/purchase-order/invoice-register-logs/${invoiceRegisterLogId}`);
};

// 송장 등록 내역 재등록 완료 표시 (status = failed 인 건만 가능, 되돌리기 없음)
// 존재하지 않는 내역 / 이미 재등록 완료 / 등록 성공 건은 400
export const resolveInvoiceRegisterLog = (invoiceRegisterLogId: number): Promise<AxiosResponse<InvoiceRegisterLog>> => {
    return client.put(`${BASE_URL}/v1/admin/purchase-order/invoice-register-logs/${invoiceRegisterLogId}/resolve`);
};

// 송장 등록 상태 확인 (폴링용, jobStatus = done 이면 처리 완료)
export const getInvoiceRegisterStatus = (
    invoiceRegisterLogId: number,
): Promise<AxiosResponse<InvoiceRegisterResult>> => {
    return client.get(`${BASE_URL}/v1/admin/purchase-order/invoice-register-logs/${invoiceRegisterLogId}/status`);
};

export const updateInvoiceNumber = (invoiceData: InvoiceData): Promise<AxiosResponse<DeliveryInvoiceNumberUpdate>> => {
    return noTimeoutClient.put<DeliveryInvoiceNumberUpdate>(
        `${BASE_URL}/v1/admin/order-item-products/deliveryInvoiceNumber`,
        invoiceData,
    );
};

export const updateOrderItemProductStatus = (
    orderItemId: number,
    productId: number,
    orderItemProductStatus: string,
) => {
    return noTimeoutClient.put(`${BASE_URL}/v1/admin/order-item-products/status`, {
        orderItemId,
        productId,
        orderItemProductStatus,
    });
};

export const uploadInvoiceNumber = (
    invoiceData: InvoiceData[],
): Promise<AxiosResponse<DeliveryInvoiceNumberUpdate>> => {
    return noTimeoutClient.put<DeliveryInvoiceNumberUpdate>(
        `${BASE_URL}/v1/admin/order-item-products/deliveryInvoiceNumbers`,
        invoiceData,
    );
};

export const uploadInvoiceNumberWithFormData = (file: File): Promise<AxiosResponse<boolean>> => {
    const form = new FormData();
    form.append('file', file);
    return noTimeoutClient.post(`${BASE_URL}/v1/admin/order-item-products/delivery-invoice-numbers`, form);
};

export const getUnmatchedInvoiceList = (): Promise<AxiosResponse<OrderItem[]>> => {
    return noTimeoutClient.get<OrderItem[]>(`${BASE_URL}/v1/admin/order-items/unmatch-deliveries`);
};

export const getOrderItemProductStatusLog = (
    orderItemId: number,
    productId: number,
): Promise<AxiosResponse<OrderItemProductStatusLog[]>> =>
    noTimeoutClient.get(`${BASE_URL}/v1/admin/order-item-products/${orderItemId}/${productId}/status-log`);

export const getInvoiceLogs = (page: number, take: number): Promise<AxiosResponse<Page<InvoiceLog>>> =>
    noTimeoutClient.get(`${BASE_URL}/v1/admin/log/update-delivery-invoice?take=${take}&page=${page}`);

export const downloadExcel = async (url: string): Promise<any> => {
    return (
        await axios.get(url, {
            responseType: 'blob',
        })
    ).data;
};

export const getNoInvoice = (
    page: number,
    take: number,
    beginDate: string,
    endDate: string,
    distributorName: string,
    productName: string,
): Promise<AxiosResponse<Page<EmptyInvoice>>> => {
    return client.get(
        `${BASE_URL}/v1/admin/purchase-order/no-invoice?page=${page}&take=${take}&beginDate=${format(
            new Date(beginDate),
            'yyyy-MM-dd',
        )}&endDate=${format(new Date(endDate), 'yyyy-MM-dd')}${
            distributorName ? `&distributorName=${distributorName}` : ``
        }${productName ? `&productName=${productName}` : ``}`,
    );
};

export const getNoInvoiceExcel = (
    beginDate: string,
    endDate: string,
    distributorName: string,
    productName: string,
): Promise<AxiosResponse<ExcelDownloadSummary>> => {
    return client.post(
        `${BASE_URL}/v1/admin/purchase-order/no-invoice/excel?&beginDate=${format(
            new Date(beginDate),
            'yyyy-MM-dd',
        )}&endDate=${format(new Date(endDate), 'yyyy-MM-dd')}${
            distributorName ? `&distributorName=${distributorName}` : ``
        }${productName ? `&productName=${productName}` : ``}`,
    );
};
